"use client";

import { Box, Collapse, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import { useId, useState } from "react";
import CopyCitationButton from "@/src/components/common/copy-citation-button/copy-citation-button";
import DisclosureButton from "@/src/components/common/broadsheet/disclosure-button";
import Panel from "@/src/components/common/broadsheet/panel";

const ArticleCite = ({
  howToCite,
  sx,
}: {
  howToCite: string;
  sx?: SxProps<Theme>;
}) => {
  const [open, setOpen] = useState(false);
  const panelId = `${useId()}-how-to-cite`;

  return (
    <Box
      sx={[
        { mt: 0.5, textAlign: "center" },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <DisclosureButton
        label="How to Cite"
        open={open}
        onToggle={() => setOpen(!open)}
        controls={panelId}
      />
      <Collapse in={open}>
        <Panel
          id={panelId}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 0.5,
            mt: 0.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              flexGrow: 1,
              textAlign: "left",
              fontSize: "0.875rem",
              lineHeight: 1.6,
            }}
          >
            {howToCite}
          </Typography>
          <CopyCitationButton text={howToCite} />
        </Panel>
      </Collapse>
    </Box>
  );
};

export default ArticleCite;
